'use strict';

import angular from 'angular';
import ListController from './list.controller';

export default angular.module('updateServerApp.appstore.list', [])
  .controller('AppStoreListController', ListController)
  .name;



// WEBPACK FOOTER //
// ./client/app/appstore/list/index.js